import { DialogOptionsDto } from "../dto";
import { IDialogModel } from "../models";

export const TokenIDialogService = "IDialogService";
export interface IDialogService {
    ShowDialog(url: string, options?: DialogOptionsDto, callback?: (dialog: IDialogModel) => void): void;
    MessageParent( messageObject : string): void;
    SaveSessionDataDialog( sessionData : string): void;
}